import { computed } from 'vue';
import { getSportLiveTvTeams } from '@/api/sport-live-tv';
import { useAsyncData } from '@/composables/use-async-data';
import { SPORT_LIVE_TV_TEAMS_LIMIT } from '@/sport-live-tv/constants';

export const useSportLiveTvTeams = () => {
  const { data } = useAsyncData(() => getSportLiveTvTeams(0, SPORT_LIVE_TV_TEAMS_LIMIT));

  return computed(() => data.value ?? []);
};
